(window.AddressBook = function (Behaviors) {

  "use strict";
  
  function AddressBook(elem) {
    Behaviors.init(AddressBook, this, arguments)

    this.template = this.$elem[0];
    
    this.template.querySelector('.js-new-address').addEventListener('click', ()=> {
      this.template.querySelector('.add-new-address').classList.toggle('add-new-address--active');
    });

    this.template.querySelector('.js-new-address-cancel').addEventListener('click', ()=> {
      this.template.querySelector('.add-new-address').classList.toggle('add-new-address--active');
    });

    this.template.querySelectorAll('.address-delete').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        let target = evt.target.dataset.target;
        let confirmMessage = evt.target.dataset.confirmMessage;

        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' }
          });
        }
      });
    });

    this.template.querySelectorAll('.address-edit-toggle').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        let formId = evt.target.dataset.formId;
        
        document.querySelector(`.edit-address[data-form="${formId}"]`).classList.toggle('edit-address--active');
        
      });
    });

    // Initialize each edit form's country/province selector
    this.template.querySelectorAll('.address-country-option').forEach(function(option) {
      var formId = option.dataset.formId;
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
      });
    });
  }

  Behaviors.inherit(AddressBook, Behaviors.Behavior);
  AddressBook.QUERY = '.template-addresses';

  Behaviors.register_behavior(AddressBook);
  
  return AddressBook;

  }(window.Behaviors));